import { extend } from 'vee-validate'
import { required, min_value, email, length } from 'vee-validate/dist/rules'
import moment from 'moment'

function stripMobilePrefix(number) {
	number = number.replace(/^(\+)/, '')
	number = number.replace(/^(00)/, '')
	number = number.replace(/^(44)/, '')
	const zeroRegex = /^0/i
	if (zeroRegex.exec(number) === null) {
		number = '0' + number
	}
	return number
}
function removeSpaces(number) {
	number = number.replace(/ /g,'')
	return number
}

extend('required', {
	...required,
	message: (field) => {
		return 'This field is required'
	},
})

extend('email', email)

extend('min_value', {
	...min_value,
	message: (field) => {
		return 'The ' + field + " can't be smaller than 0"
	},
})

extend('smaller_than', {
	validate: (value, { compareTo }) => {
		return parseInt(value) <= parseInt(compareTo)
	},
	message: 'Invalid amount',
	params: ['compareTo'],
})

extend('mobile_phone', {
	...required,
	validate: (value, { length }) => {
		value = stripMobilePrefix(value)
		const regex = /^070|^071|^072|^073|^074|^075|^076|^077|^078|^079/i
		return regex.exec(value) !== null && value.length == length
	},
	message: 'Please provide a valid mobile number',
	params: ['length'],
})
extend('mobile_phone_length', {
	...length,
	validate: (value, { length }) => {
		value = stripMobilePrefix(value)
		return value.length === length
	},
	message: (field, { length }) => {
		return 'Please provide a valid phone number'
	},
})
extend('uk_number', {
	params: ['min', 'max'],
	validate: (value, { min, max }) => {
        if(typeof value === 'undefined'){
            return false
        }
        if(value === null){
            return false
        }
		value = stripMobilePrefix(value)
		value = removeSpaces(value)
		let regex = /^01|^02|^03|^04|^05|^06|^07|^08|^09|/i
		if (regex.exec(value) === null) {
			return false
		}

		return value.length === Number(min) || value.length === Number(max)
	},
	message: (field, { min, max }) => {
		return 'Please provide a valid UK phone number'
	},
})
extend('date_within_30', {
	...required,
	message: 'The date has to be within 30 days',
	validate: (value) => {
		let inputDate = moment(value)
		return (
			inputDate.isAfter(moment().subtract(1, 'days')) &&
			inputDate.isBefore(moment().add(31, 'days'))
		)
	},
})

extend('date_within_60', {
	...required,
	message: 'The date has to be within 60 days',
	validate: (value) => {
		let inputDate = moment(value)
		return (
			inputDate.isAfter(moment().subtract(1, 'days')) &&
			inputDate.isBefore(moment().add(61, 'days'))
		)
	},
})

extend('date_within_120', {
	...required,
	message: 'The date has to be within 120 days',
	validate: (value) => {
		let inputDate = moment(value)
		return (
			inputDate.isAfter(moment().subtract(1, 'days')) &&
			inputDate.isBefore(moment().add(121, 'days'))
		)
	},
})

extend('terms', {
	...required,
	message: (field) => {
		return "Please confirm you accept our terms & conditions"
	},
})

extend('year', {
	...required,
	message: 'Please enter year. E.g. 1999',
	validate: (value) => {
		return (
			value.toString().length === 4 && /^[0-9]+$/.test(value) && value > 1900// checks only digits entered
		)
	},
})

extend('yes_no', {
    validate: (value) => {
        return value !== '' && value !== undefined; // Ensure something is selected
    },
    message: 'Please select Yes or No.',
});